// Masters section index — every master in one place, grouped logically.

import { AppShell } from '@/components/AppShell';
import { MASTERS, Tile, TileGroup } from '@/pages/Gateway';

export function MastersSectionPage() {
  return (
    <AppShell
      pageHeader={
        <div>
          <h1 className="font-display text-display-md font-semibold text-obsidian" style={{ letterSpacing: 'var(--tracking-display)' }}>
            Masters
          </h1>
          <p className="mt-1 text-body-sm text-slate">Reference data that shapes every transaction.</p>
        </div>
      }
    >
      <TileGroup label="Masters" hint="Customers, items, ledgers — the building blocks of every voucher" kind="slate">
        <div className="orz-stagger grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {MASTERS.map((t) => <Tile key={t.title} {...t} />)}
        </div>
      </TileGroup>
    </AppShell>
  );
}
